import { MainContentLayout } from 'shared/ui/layout';

import { AddConnectorInstruction } from 'features/instruction/add-connector-instruction';

export function AddConnectorInstructionPage() {
  return <MainContentLayout element={<AddConnectorInstruction />} />;
}
